import { ApplyButton } from 'components/ApplyButton/ApplyButton';
import { DesktopOnly } from 'components/Breakpoint/DesktopOnly';
import { SaveButton } from 'components/SaveButton/SaveButton';
import { ShareListingButton } from 'components/ShareListingButton/ShareListingButton';
import type { ApiVolop } from 'modules/listing/api/volop/types/ApiVolop';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { ListingViewActionButtons } from 'modules/listing/components/ListingView/ActionButtons/ListingViewActionButtons';
import type { OrgDashboardApiVolop } from 'modules/orgDashboard/api/listing/types/OrgDashboardApiVolop';

type Props = {
  volop: ApiVolop | OrgDashboardApiVolop;
};

export function ViewVolopActionButtons({ volop }: Props) {
  const { id, type, hasAts, name, url, org } = volop;

  return (
    <ListingViewActionButtons>
      <ApplyButton atsIsEnabled={hasAts} listingId={id} size="medium" />

      <SaveButton
        listingId={id}
        listingType={type}
        listingName={name}
        orgId={org?.id}
        orgName={org?.name}
        orgType={org?.orgType}
      />

      <DesktopOnly>
        <ShareListingButton
          disabled={!url}
          listingId={id}
          listingType={type}
          listingUrl={url}
        />
      </DesktopOnly>

      <ListingActionsDropdown
        hasAts={hasAts}
        listingId={id}
        listingType={type}
        listingUrl={url}
        orgId={org?.id}
        orgName={org?.name}
        orgType={org?.orgType}
      />
    </ListingViewActionButtons>
  );
}
